export default function WaveField({ variant = "light", className = "" }) {
  const c =
    variant === "dark"
      ? ["#F2C230", "#C4B5FD", "#8B5CF6", "#F2C230", "#8B5CF6", "#C4B5FD"]
      : ["#2B0A4E", "#8B5CF6", "#F2C230", "#2B0A4E", "#8B5CF6", "#F2C230"];
  return (
    <svg
      viewBox="0 0 620 440"
      fill="none"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMaxYMax slice"
    >
      <path d="M640 420 C 500 380, 470 270, 380 250 C 290 230, 250 130, 90 90" stroke={c[0]} strokeWidth="30" strokeLinecap="round" />
      <path d="M650 360 C 520 330, 480 230, 395 210 C 310 190, 265 100, 110 55" stroke={c[1]} strokeWidth="22" strokeLinecap="round" />
      <path d="M655 305 C 535 280, 495 190, 415 170 C 335 150, 285 70, 140 25" stroke={c[2]} strokeWidth="16" strokeLinecap="round" />
      <path d="M640 460 C 480 430, 440 320, 350 300 C 260 280, 220 180, 60 140" stroke={c[3]} strokeWidth="12" strokeLinecap="round" opacity="0.7" />
      <path d="M660 250 C 550 230, 510 150, 435 130 C 360 110, 315 40, 180 5" stroke={c[4]} strokeWidth="10" strokeLinecap="round" opacity="0.7" />
      <path d="M620 480 C 470 460, 420 360, 330 340 C 240 320, 200 230, 40 190" stroke={c[5]} strokeWidth="8" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}
